import _ from "lodash";
import classNames from "classnames";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import ChangeTaskType from "ClassRoom/components/ChangeTaskType";
import classes from "./LibraryBody.scss";
import DialogActionModal from "UIComponents/DialogActionModal";
import I18nHOC from "UIComponents/I18nHOC";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import {
  importAssessment,
  updateFilters,
  cloneAssessment,
  gotoAssessmentDetails,
} from "Assessments/modules/AssessmentModule";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import AddLE from "./AddLE";
import { updateCoachMarkStatus } from "modules/CoachMarksModule";
import { EmptyLE, EmptyAssessment } from "SvgComponents";
import FeedsContainer from "./FeedsContainer";
import { SearchInput } from "@toddle-edu/ds-web";
import AddAssignment from "ClassRoom/components/AddAssignment";
import {
  PLACEHOLDER_RECT_IMAGE,
  PLACEHOLDER_RECT_IMAGE_COUNT,
} from "Constants";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import { getLELibraryLabelsMemoize } from "UnitPlans/modules/Utils";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import { getUnitFlowUtils } from "UnitFlowV3/modules/utils";
import ACLStore from "lib/aclStore";

const TYPE_DETAILS = {
  ASSESSMENT: {
    label: "common:assessment_label_plural",
    placeholder: "E.g. Sorting and classfiying etc.",
    noDataComp: () => <EmptyAssessment />,
  },
  LEARNING_ENGAGEMENT: {
    label: "common:le_label_plural",
    placeholder: "E.g. Readings: Myths, Legends etc.",
    noDataComp: () => <EmptyLE />,
  },
  SECOND_STAGE_ASSESSMENT: {
    label: "common:stage_2_assessment_plural",
    placeholder: "E.g. Sorting and classfiying etc.",
    noDataComp: () => <EmptyAssessment />,
  },
  THIRD_STAGE_ASSESSMENT: {
    label: "common:stage_3_assessment_plural",
    placeholder: "E.g. Sorting and classfiying etc.",
    noDataComp: () => <EmptyAssessment />,
  },
};

const getAssignmentModalData = ({ t }) => {
  return {
    mode: "create",
    creationMode: "ASSIGN_TO_CLASS",
    steps: [
      {
        label: t("common:edit_with_label", {
          label: t("common:post"),
        }),
        value: "ASSESSMENT_DETAILS",
      },
      {
        label: t("classRoom:post_settings"),
        value: "SETTINGS",
      },
    ],
    contentType: "ASSESSMENT",
    createHeader: t("common:assign_to_students"),
    updateUnitPlanDataInRedux: false,
  };
};

const DIALOGS_INFO = {
  DELETE: {
    title: `common:delete_with_label`,
    message: ({ t, label }) => t(`common:delete_msg_with_label`, { label }),
    confirmButtonText: "common:delete_agree",
    confirmButtonType: "destructive",
    cancelButtonText: "common:agree_cancel",
    promptDetail: ({ t, label }) => {},
  },
  DUPLICATE: {
    title: `common:duplicate_with_label`,
    message: () => "",
    confirmButtonText: "common:duplicate_agree",
    confirmButtonType: "progressive",
    cancelButtonText: "common:cancel",
    isPromptBox: true,
    promptDetail: ({ t, label, currentDialogItem }) => {
      const name = currentDialogItem?.title?.value || "";
      return {
        placeholder: t("common:assessment_input_emptyText"),
        label: t("common:name_of_the_with_label", { label }),
        checkValidation: true,
        promptText: t("common:label_copy", { label: name }),
      };
    },
  },
};

const DIALOGS_INFO_UNIT_FLOW_REVAMP = {
  DELETE: {
    title: `common:delete_with_quotation_label`,
    message: ({ assessmentName, label }) => (
      <Trans
        i18nKey={"unitPlan:delete_assessment_with_label"}
        values={{ assessmentName, label }}
      />
    ),
    repeatedAssessmentMessage: ({ assessmentName, label }) => (
      <Trans
        i18nKey={"unitPlan:delete_assessment_and_repetitions_with_label"}
        values={{ assessmentName, label }}
      />
    ),
    confirmButtonText: "common:delete",
    confirmButtonType: "destructive",
    cancelButtonText: "common:cancel",
    promptDetail: ({ t, label }) => {},
  },
  DUPLICATE: {
    title: `common:duplicate_with_quoted_label`,
    message: () => "",
    repeatedAssessmentMessage: () => "",
    confirmButtonText: "common:duplicate",
    confirmButtonType: "progressive",
    cancelButtonText: "common:cancel",
    isPromptBox: true,
    promptDetail: ({ t, currentDialogItem }) => {
      const name = currentDialogItem?.title?.value || "";
      return {
        placeholder: t("common:assessment_input_emptyText"),
        label: t("common:title"),
        checkValidation: true,
        promptText: t("common:label_copy", { label: name }),
      };
    },
  },
};

class LibraryBody extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentDialogAction: "",
      showAdd: false,
      isLoading: false,
      fullScreenLoading: false,
      showAssignToStudentsModal: false,
      clonedAssessmentId: null,
      item: {},
      changeTaskTypeModalData: {},
    };
    this.currentDialogItem = {};
    this.searchBar = null;
  }

  componentDidMount = () => {
    // this.resetSearchBar();
  };

  // resetSearchBar = () => {
  //   if (this.searchBar) {
  //     this.searchBar.cancelText();
  //   }
  // };

  OnToggleDialogueClick = () => {
    this.setState({
      currentDialogAction: "",
    });
    this.currentDialogItem = {};
  };

  onDialogConfirmClick = promptText => {
    const { currentDialogAction } = this.state;
    switch (currentDialogAction) {
      case "DELETE":
        this.props.onDeleteClick(this.currentDialogItem.id);
        break;
      case "DUPLICATE":
        this.props.onDuplicateClick(this.currentDialogItem.id, promptText);
    }
    this.OnToggleDialogueClick();
  };

  onPrintClick = item => {
    this.props.onPrintClick(item.id);
  };

  onCardClicked = ({ id, mode = "view" }) => {
    this.setState({ showAdd: false });

    this.props.onCardClicked({ id: id, mode });
  };

  onDeleteClick = item => {
    this.setState({
      currentDialogAction: "DELETE",
    });
    this.currentDialogItem = item;
  };

  onDuplicateClick = item => {
    this.setState({
      currentDialogAction: "DUPLICATE",
    });
    this.currentDialogItem = item;
  };

  onCloseAddToStudentModal = () => {
    this.setState({ showAssignToStudentsModal: false });
  };

  onAssignToStudentClick = async item => {
    // In case of single assessment copy do not import assessment
    // assign same assessment in class
    if (ACLStore.can("FeatureFlag:SingleAssessmentCopy")) {
      this.setState({
        clonedAssessmentId: _.get(item, "id"),
        item,
        showAssignToStudentsModal: true,
      });
      return;
    }

    const { cloneAssessment, courseAcademicYearsIds } = this.props;

    this.setState({ fullScreenLoading: true, item });
    const { clonedAssessmentId } = await cloneAssessment({
      sourceAssessmentId: _.get(item, "id"),
      portalType: "PLANNER",
      academicYears: courseAcademicYearsIds,
    });
    this.setState({ clonedAssessmentId });
    this.setState({ fullScreenLoading: false });
    if (clonedAssessmentId) {
      this.setState({ showAssignToStudentsModal: true });
    }
  };

  setLoadingState = (value, key) => {
    if (key === "LOADING") this.setState({ isLoading: value });
    else if (key === "FULLSCREEN_LOADING")
      this.setState({ fullScreenLoading: value });
  };

  onLeSearchImportSuccess = () => {
    const { updateCoachMarkStatus } = this.props;
    updateCoachMarkStatus({
      type: "IMPORT_LE_FROM_COMMUNITY_UNIT_PLAN",
      portalType: "PLANNER",
    });
  };

  onCreateNewLESuccess = ({ id }) => {
    const { gotoAssessmentDetails } = this.props;
    gotoAssessmentDetails({
      id,
      mode: "create",
      isOpenInNewTab: false,
    });
  };

  onSearchChange = value => {
    const { updateFilters } = this.props;
    updateFilters({ searchText: value });
  };

  onChangeTaskTypeClick = item => {
    this.setState({ changeTaskTypeModalData: item });
  };

  handleChangeTaskTypeClose = () =>
    this.setState({ changeTaskTypeModalData: {} });

  render() {
    const {
      props: {
        label,
        readOnly,
        list,
        t,
        unitPlanId,
        size,
        groupType,
        curriculumType,
        assessmentTypeGroup,
        assessmentTypes,
        assessmentTypeDetail,
        isFilteredData,
        onPrintClick,
        courseId,
        course,
        i18n,
        isDragEnabled,
        handleRightPane,
        isUnitFlowRevamp,
        onClose,
        testId,
      },
    } = this;

    const {
      currentDialogAction,
      fullScreenLoading,
      isLoading,
      showAssignToStudentsModal,
      clonedAssessmentId,
      item,
      changeTaskTypeModalData,
    } = this.state;
    const { id, title, image } = item;
    const assignmentModalData = getAssignmentModalData({
      t,
    });
    const listLength = _.get(list, "length", 0);

    const assessmentType = assessmentTypeGroup
      ? assessmentTypeGroup
      : groupType;

    const dialogItemTitle = _.trim(
      _.get(this.currentDialogItem, "title.value", "")
    );

    const itemHaveLinkedCopies =
      _.size(_.get(this.currentDialogItem, "unitFlowResources", [])) > 0;

    const feedContainerClass = classNames(classes.feedContainer, {
      [classes.feedContainerUnitFlowRevamp]: isUnitFlowRevamp,
    });
    return (
      <React.Fragment>
        <div className={classes.mainContainer}>
          <div>
            <AddLE
              assessmentTypes={assessmentTypes}
              assessmentTypeDetail={assessmentTypeDetail}
              onSearchChange={this.onSearchChange}
              curriculumType={curriculumType}
              portalType="COMMUNITY"
              list={list}
              label={label}
              readOnly={readOnly}
              unitPlanId={unitPlanId}
              eventTarget={"unit - learning experiences library"}
              setLoadingState={this.setLoadingState}
              isLoading={isLoading}
              showCoachmark={true}
              size={size}
              groupType={groupType}
              assessmentTypeGroup={assessmentTypeGroup}
              onCreateNewLESuccess={this.onCreateNewLESuccess}
              onClose={onClose}
              testId={testId}
            />
          </div>
          {!isUnitFlowRevamp && (
            <div className={classes.searchContainer}>
              <SearchInput
                placeholder={getLELibraryLabelsMemoize({
                  assessmentType,
                  assessmentTypeDetail,
                  labelType: "searchText",
                  t,
                  lng: _.get(i18n, "language", "en"),
                })}
                onChange={this.onSearchChange}
                testId={testId}
                // ref={ref => (this.searchBar = ref)}
              />
            </div>
          )}
          {readOnly && listLength == 0 && (
            <div className={classes.emptyText}>{`No ${label}`}</div>
          )}
          <div className={feedContainerClass}>
            <FeedsContainer
              list={list}
              assessmentTypeDetail={assessmentTypeDetail}
              readOnly={readOnly}
              size={size}
              curriculumType={curriculumType}
              isLoading={this.props.isLoading}
              isData={isFilteredData}
              onDeleteClick={this.onDeleteClick}
              onDuplicateClick={this.onDuplicateClick}
              onPrintClick={onPrintClick}
              onAssignToStudentClick={this.onAssignToStudentClick}
              onCardClicked={this.onCardClicked}
              assessmentType={assessmentType}
              isDragEnabled={isDragEnabled}
              isUnitFlowRevamp={isUnitFlowRevamp}
              onChangeTaskTypeClick={this.onChangeTaskTypeClick}
              testId={testId}
            />
          </div>

          {this.state.isLoading ? (
            <div className={classes.modalContent}>
              <FullScreenLoader />
            </div>
          ) : null}
          {!!currentDialogAction && (
            <DialogActionModal
              modalTitle={
                isUnitFlowRevamp
                  ? t(
                      DIALOGS_INFO_UNIT_FLOW_REVAMP[currentDialogAction].title,
                      { label: dialogItemTitle }
                    )
                  : t(DIALOGS_INFO[currentDialogAction].title, { label })
              }
              dsVersion={isUnitFlowRevamp ? "2.0" : "1.0"}
              onClickButton2={this.onDialogConfirmClick}
              message={
                isUnitFlowRevamp
                  ? itemHaveLinkedCopies
                    ? DIALOGS_INFO_UNIT_FLOW_REVAMP[
                        currentDialogAction
                      ].repeatedAssessmentMessage({
                        label: dialogItemTitle,
                        assessmentName: label,
                      })
                    : DIALOGS_INFO_UNIT_FLOW_REVAMP[
                        currentDialogAction
                      ].message({
                        label: dialogItemTitle,
                        assessmentName: label,
                      })
                  : DIALOGS_INFO[currentDialogAction].message({ t, label })
              }
              onClose={this.OnToggleDialogueClick}
              button1={
                isUnitFlowRevamp
                  ? t(
                      DIALOGS_INFO_UNIT_FLOW_REVAMP[currentDialogAction]
                        .cancelButtonText
                    )
                  : t(DIALOGS_INFO[currentDialogAction].cancelButtonText) ||
                    t("common:cancel")
              }
              button2Variant={
                DIALOGS_INFO[currentDialogAction].confirmButtonType
              }
              button2={
                isUnitFlowRevamp
                  ? t(
                      DIALOGS_INFO_UNIT_FLOW_REVAMP[currentDialogAction]
                        .confirmButtonText
                    )
                  : t(DIALOGS_INFO[currentDialogAction].confirmButtonText)
              }
              isPromptBox={DIALOGS_INFO[currentDialogAction].isPromptBox}
              promptDetail={
                isUnitFlowRevamp
                  ? DIALOGS_INFO_UNIT_FLOW_REVAMP[
                      currentDialogAction
                    ].promptDetail({
                      t,
                      currentDialogItem: this.currentDialogItem,
                    })
                  : DIALOGS_INFO[currentDialogAction].promptDetail({
                      t,
                      label,
                      currentDialogItem: this.currentDialogItem,
                    })
              }
            />
          )}
        </div>
        {fullScreenLoading && <FullScreenLoader />}
        {showAssignToStudentsModal && (
          <AddAssignment
            sourceAssessmentId={id}
            mode={assignmentModalData["mode"]}
            creationMode={assignmentModalData["creationMode"]}
            steps={assignmentModalData["steps"]}
            contentType={assignmentModalData["contentType"]}
            createHeader={assignmentModalData["createHeader"]}
            onClose={this.onCloseAddToStudentModal}
            portalType={"PLANNER"}
            assignmentDetails={{
              assignmentImage:
                image.value ||
                PLACEHOLDER_RECT_IMAGE[id % PLACEHOLDER_RECT_IMAGE_COUNT],
              assignmentTitle: title.value ?? t("common:untitled"),
            }}
            showImageTitleInHeader={true}
            clonedAssessmentId={clonedAssessmentId}
            courseId={courseId}
            course={course}
            updateUnitPlanDataInRedux={
              assignmentModalData["updateUnitPlanDataInRedux"]
            }
            isFromUnitPlan={true}
            showInModal={true}
            assessmentType={_.get(item, "assessmentType.value", null)}
          />
        )}

        {!_.isEmpty(changeTaskTypeModalData) ? (
          <ChangeTaskType
            handleClose={this.handleChangeTaskTypeClose}
            assessmentTypeObj={_.get(
              changeTaskTypeModalData,
              "assessmentType",
              null
            )}
            pageType={"UNIT_FLOW_RIGHT_PANE"}
            assessmentId={_.get(changeTaskTypeModalData, "id", null)}
            unitPlanId={unitPlanId}
            handleRightPane={handleRightPane}
            title={_.get(changeTaskTypeModalData, "title", {})}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const filters = _.get(state, "assessment.filters", {});
  const { assessmentTypeGroup, groupType } = ownProps;
  const assessmentTypeDetail =
    TYPE_DETAILS[assessmentTypeGroup ? assessmentTypeGroup : groupType];
  const courseId = state.teacher.selected_class.selected_course;
  const academicYearId = getSelectedAcademicYearId(state);
  const courseGradeFilters = {
    academicYearId,
  };
  const courseDetails = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters,
  });
  const courseAcademicYearsIds = _.map(
    _.get(courseDetails, "academicYears", []),
    item => item.id
  );
  const { isUnitFlowRevampEnabled } = getUnitFlowUtils();
  const isUnitFlowRevamp = isUnitFlowRevampEnabled();

  return {
    filters,
    assessmentTypeDetail,
    courseId,
    courseAcademicYearsIds,
    course: courseDetails,
    isUnitFlowRevamp,
  };
};

const mapActionCreators = {
  importAssessment,
  updateCoachMarkStatus,
  gotoAssessmentDetails,
  updateFilters,
  cloneAssessment,
};

LibraryBody.propTypes = {
  list: PropTypes.array,
  onCardClicked: PropTypes.func,
  createText: PropTypes.string,
  onClose: PropTypes.func,
};

LibraryBody.defaultProps = {
  list: [],
  createText: "",
  size: "small",
  onClose: () => {},
};

export default compose(
  I18nHOC({ resource: ["common", "toastMsgs"] }),
  connect(mapStateToProps, mapActionCreators)
)(LibraryBody);
